/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import APIRequest from "./index";

export function listApplication(mark, pageSize, callback) {
  return APIRequest('get', '/lora/applications?access_token=&count', {
    mark: mark,
    pageSize: pageSize
  }, {}, callback);
}

export function getApplication(id, callback) {
  return APIRequest('get', '/lora/applications/' + id, {}, {}, callback);
}

export function editApplication(id, name, target, token, callback) {
  return APIRequest('put', '/lora/applications/' + id, {}, {
    name: name,
    target: target,
    token: token
  }, callback);
}

export function addApplication(name, appeui, callback) {
  return APIRequest('post', '/lora/applications', {}, {
    name: name,
    appeui: appeui
  }, callback);
}

export function delApplication(id,callback) {
  return APIRequest('del','/lora/applications/'+id, {}, {}, callback);
}

export function getApplicationOnQuery(args, callback) {
  return APIRequest('get','/lora/applications', args, {}, callback);
}

export function getApplicationsCount(callback) {
  return APIRequest('get','/lora/applications/count',{}, {}, callback);
}


export function getAppTokenList(appId,callback) {
  return APIRequest('get', '/tokens', {bind:appId}, {}, callback);
}

export function addAppToken(appId,name, callback) {
  return APIRequest('post', '/tokens', {}, {
    bind:appId,
    name: name
  }, callback);
}

export function deleteAppToken(id, callback) {
  return APIRequest('del', '/tokens/'+id, {}, {}, callback);
}





// WEBPACK FOOTER //
// ./src/api/lora_application.js